import { Link } from "react-router-dom";
import { Logo } from "@/components/ui/Logo";
import { PublicFooter } from "@/components/layout/PublicFooter";

interface StaticPageLayoutProps {
  children: React.ReactNode;
  title: string;
  description?: string;
}

const StaticPageLayout = ({ children, title, description }: StaticPageLayoutProps) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/">
            <Logo size="md" />
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              About
            </Link>
            <Link to="/help" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Help
            </Link>
            <Link to="/auth" className="text-sm font-medium text-primary hover:text-primary/80 transition-colors">
              Sign In
            </Link>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <div className="container mx-auto px-6 py-12 md:py-16 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-semibold text-foreground mb-4 tracking-tight">
            {title}
          </h1>
          {description && (
            <p className="text-lg text-muted-foreground mb-10 leading-relaxed">
              {description}
            </p>
          )}
          <div className="prose prose-neutral dark:prose-invert max-w-none">
            {children}
          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
};

export default StaticPageLayout;
